export enum CAMPAIGN_TYPE {
  Organization = 'Org',
  User = 'user'
}

export const allCampaignTypeOptions = [
  {
    label: 'Organization',
    value: CAMPAIGN_TYPE.Organization
  },
  {
    label: 'User',
    value: CAMPAIGN_TYPE.User
  }
];